module.exports = __webpack_public_path__ + "img/16.ea9e537f.jpg";